import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceService } from './../../../shared/services/service.service';
import { ActiveUserLocalDataService } from './../../../shared/services/active-user-local-data.service';
import { GetRegisteredCarFaultsResponse, GetInServiceCarFaultsResponse, PostCarFaultRequest } from './../../../shared/models/service.models';

@Component({
  templateUrl: 'service-manage-car-faults.component.html',
  styleUrls: ['./service-manage-car-faults.component.scss']
})
export class ServiceManageCarFaultsComponent implements OnInit {
  comments: { text: string }[] = [];
  registeredCarFaultsResponse: GetRegisteredCarFaultsResponse | null = null;
  inServiceCarFaultsResponse: GetInServiceCarFaultsResponse | null = null;
  loading: boolean = true;
  flag: boolean = true;

  constructor(
    private serviceService: ServiceService,
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadFaults();
  }

  async loadFaults() {
    const carId = this.activeUserLocalDataService.activeServiceVoucher?.carsId;
    if (!carId) {
      this.router.navigate(['/service-pick-car']);
      return;
    }
  
    const registeredCarFaultsResponse = await this.serviceService.getRegisteredCarFaults({ carId }).toPromise();
    
    const inServiceCarFaultsResponse = await this.serviceService.getInServiceCarFaults({ carId }).toPromise();
  
    this.registeredCarFaultsResponse = registeredCarFaultsResponse ?? null;
    this.inServiceCarFaultsResponse = inServiceCarFaultsResponse ?? null;
    this.loading = false;
  }

  addComment() {
    this.comments.push({ text: '' });
  }

  async continueNextStep() {
    const carId = this.activeUserLocalDataService.activeServiceVoucher?.carsId;
    const voucherId = this.activeUserLocalDataService.activeServiceVoucher?.id;

    for (const comment of this.comments) {
      if (comment.text.trim()) {
        await this.serviceService.postCarFault({ carId, voucherId, faultNotes: comment.text }).toPromise();
      }
    }

    this.router.navigate(['/service-voucher']);
  }

  navigateToService() {
    this.router.navigate(['/service-voucher']);
  }

  onContentReady(e: any) {
    if (this.flag) {
      e.component.expandItem(0);
      e.component.expandItem(1);
      this.flag = false;
    }
  }
}